












import { Component, Prop, Vue } from 'vue-property-decorator'
import xDialog from '@finance/ssvue/src/components/x-dialog/index.vue'

@Component({
  name: 'rain-dialog',
  components: {
    xDialog
  }
})
export default class RainDialog extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop(Number) goldNum!: number;
  @Prop(Array) prizeList!: any[];
  close() {
    this.$emit('input', false)
    this.$emit('onClose')
    console.log(this.prizeList)
  }
}
